var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{staticClass:"am-input-file__input",attrs:{"type":"file"},on:{"change":_vm.fileChanged}})}
var staticRenderFns = []

export { render, staticRenderFns }